import { SideMenuRevisor } from './SideMenuRevisor';
import { useJwt } from 'react-jwt';
import { useEffect, useState } from 'react';
import { TopicsList } from '../../../data/TopicsList';
import { Link } from 'react-router-dom';
import { LoadingLayer } from '../../LoadingLayer';
import PropTypes from 'prop-types';

export const fetchRevisorAbstracts = async (user_groups, setAbstracts, cognitoUser) => {
  let category = '';
  if (user_groups.includes('revisor-advanced-materials-and-physics-of-nanostructures')) {
    category = 'Advanced materials and physics of nanostructures';
  } else if (user_groups.includes('revisor-bionanotechnology')) {
    category = 'Bionanotechnology';
  } else if (user_groups.includes('revisor-nanophotonics')) {
    category = 'Nanophotonics';
  } else if (
    user_groups.includes('revisor-physical-chemistry-of-nanomaterials-and-nanocatalysis')
  ) {
    category = 'Physical-chemistry of nanomaterials and nanocatalysis';
  } else if (user_groups.includes('revisor-tech-inovation-in-science')) {
    category = 'Tech innovation in nanoscience';
  }
  try {
    const response = await fetch(
      'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/revisors/abstracts',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'user-token': localStorage.getItem('id_token'),
        },
        body: JSON.stringify({ category: category }),
      },
    );
    if (response.status === 401) {
      return response.status;
    }
    const data = await response.json();
    let tempAbstracts = data.Items;
    for (let i = 0; i < tempAbstracts.length; i++) {
      tempAbstracts[i].abstractKey = (
        tempAbstracts[i].category
          .split(' ')
          .map((c) => c[0])
          .join('') +
        '-' +
        (i + 1)
      ).toUpperCase();
    }
    console.log(cognitoUser);
    setAbstracts(
      tempAbstracts.filter((a) => {
        return (
          a.status === 'Sent' && (a.score ? a.score.length < 2 : true) //&&
          // !(a.score ? a.score.filter((s) => s.cognito_username === cognitoUser).length === 1 : true)
        );
      }),
    );
    return response.status;
  } catch (error) {
    return error;
  }
};

export const RevisorHome = () => {
  const [abstracts, setAbstracts] = useState([]);
  const access_token = localStorage.getItem('id_token');
  const { decodedToken } = useJwt(access_token);
  const [cognitoUser, setCognitoUser] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState('Loading');
  const [viewMode, setViewMode] = useState('table');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    console.log('decodedToken');
    if (decodedToken) {
      if (decodedToken['cognito:groups'].includes('revisor')) {
        setCognitoUser(decodedToken['cognito:username']);
        console.log(cognitoUser);
        fetchRevisorAbstracts(
          decodedToken['cognito:groups'],
          setAbstracts,
          decodedToken['cognito:username'],
        ).then(() => {
          setLoadingMessage('Done');
          setIsLoading(false);
          console.log('abstracts');
        });
      }
    }
  }, [decodedToken]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getFilteredAbstracts = (list) => {
    if (!list || !searchQuery.trim()) return list;
    const q = searchQuery.toLowerCase().trim();
    return list.filter((a) =>
      (a.title || '').toLowerCase().includes(q) ||
      (a.category || '').toLowerCase().includes(q) ||
      (a.abstractKey || '').toLowerCase().includes(q) ||
      (a.authors || []).some(
        (author) =>
          (author.name || '').toLowerCase().includes(q) ||
          (author.lastName || '').toLowerCase().includes(q),
      ),
    );
  };

  const getSortedAbstracts = (list) => {
    if (!list || !sortConfig.key) return list;
    return [...list].sort((a, b) => {
      let valA, valB;
      if (sortConfig.key === 'has_review') {
        valA = a.score && a.score.length > 0 ? 1 : 0;
        valB = b.score && b.score.length > 0 ? 1 : 0;
      } else {
        valA = (a[sortConfig.key] || '').toString().toLowerCase();
        valB = (b[sortConfig.key] || '').toString().toLowerCase();
      }
      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedAbstracts = getSortedAbstracts(getFilteredAbstracts(abstracts));

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) return <span style={{ opacity: 0.3, marginLeft: 4 }}>↕</span>;
    return <span style={{ marginLeft: 4 }}>{sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  SortIcon.propTypes = {
    columnKey: PropTypes.string.isRequired,
  };

  const categoryColors = {
    'Advanced materials and physics of nanostructures': '#6366f1',
    Bionanotechnology: '#22c55e',
    Nanophotonics: '#f59e0b',
    'Physical-chemistry of nanomaterials and nanocatalysis': '#ef4444',
    'Tech innovation in nanoscience': '#3b82f6',
  };

  return (
    <div className="snn-user-home-main-wrapper">
      <SideMenuRevisor />
      <LoadingLayer isLoading={isLoading} action={loadingMessage} />
      <div className="snn-user-home-main-content">
        <h1 className="snn-user-home-main-content-header">Welcome</h1>
        <div className="snn-user-home-main-content-grid">
          <div className="snn-expand-grid-4">
            <div>Pending abstracts to review ({abstracts.length})</div>
          </div>

          <div style={{ gridColumn: '1 / -1', minWidth: 0 }}>
          {/* View toggle */}
          <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
            <button
              onClick={() => setViewMode('cards')}
              style={{
                padding: '8px 16px',
                backgroundColor: viewMode === 'cards' ? '#0b6ef6' : '#e0e0e0',
                color: viewMode === 'cards' ? '#fff' : '#333',
                border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600,
              }}
            >
              <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginRight: 4 }}>grid_view</span>
              Cards
            </button>
            <button
              onClick={() => setViewMode('table')}
              style={{
                padding: '8px 16px',
                backgroundColor: viewMode === 'table' ? '#0b6ef6' : '#e0e0e0',
                color: viewMode === 'table' ? '#fff' : '#333',
                border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600,
              }}
            >
              <span className="material-symbols-outlined" style={{ verticalAlign: 'middle', marginRight: 4 }}>table_rows</span>
              Table
            </button>
          </div>

          {/* Search bar */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <div style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
              <span className="material-symbols-outlined" style={{
                position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                color: '#94a3b8', fontSize: '20px',
              }}>search</span>
              <input
                type="text"
                placeholder="Search by title, category or author..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{
                  width: '100%', padding: '10px 12px 10px 36px', fontSize: '14px',
                  border: '1px solid #ddd', borderRadius: '6px', outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  style={{
                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                    background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
                    fontSize: '18px', lineHeight: 1, padding: 0,
                  }}
                >×</button>
              )}
            </div>
            <span style={{ fontSize: '13px', color: '#666', whiteSpace: 'nowrap' }}>
              {sortedAbstracts ? sortedAbstracts.length : 0} / {abstracts.length} abstracts
            </span>
          </div>

          {/* Table view */}
          {viewMode === 'table' && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('title')}>
                      Title <SortIcon columnKey="title" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('category')}>
                      Category <SortIcon columnKey="category" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Authors</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}>Corresponding Author</th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd', cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('has_review')}>
                      Has Review <SortIcon columnKey="has_review" />
                    </th>
                    <th style={{ padding: '10px 12px', borderBottom: '2px solid #ddd' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {sortedAbstracts && sortedAbstracts.map((abstract) => (
                    <tr key={abstract.id + abstract.title} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '8px 12px', maxWidth: '280px' }}>
                        <Link to={`/revisor/abstracts/${abstract.id}`} style={{ color: '#0b6ef6', textDecoration: 'none' }}>
                          {abstract.title}
                        </Link>
                      </td>
                      <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                        <span style={{
                          display: 'inline-block', padding: '2px 8px', borderRadius: '12px',
                          fontSize: '12px', fontWeight: 600, color: '#fff',
                          backgroundColor: categoryColors[abstract.category] || '#94a3b8',
                        }}>
                          {abstract.category || 'N/A'}
                        </span>
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        {abstract.authors && abstract.authors.length > 0 ? (
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                            {abstract.authors.map((author, i) => (
                              <div key={i} style={{ fontSize: '12px', lineHeight: 1.4 }}>
                                <span style={{ color: '#333' }}>
                                  {author.name} {author.lastName}
                                </span>
                                <span style={{ color: '#94a3b8', fontSize: '11px' }}> — {author.degree}</span>
                                {author.correspondingAuthor && (
                                  <span title="Corresponding author" style={{ marginLeft: '4px', fontSize: '11px' }}>✉</span>
                                )}
                                {author.presentingAuthor && (
                                  <span title="Presenting author" style={{ marginLeft: '2px', fontSize: '11px' }}>🎤</span>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: '#94a3b8', fontSize: '12px' }}>No authors</span>
                        )}
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        {(() => {
                          const ca = abstract.authors?.find(a => a.correspondingAuthor);
                          if (!ca) return <span style={{ color: '#94a3b8', fontSize: '12px' }}>N/A</span>;
                          return (
                            <div style={{ fontSize: '12px' }}>
                              <div style={{ fontWeight: 600, color: '#333' }}>{ca.name} {ca.lastName}</div>
                              <div style={{ color: '#666', fontSize: '11px' }}>{ca.degree}</div>
                            </div>
                          );
                        })()}
                      </td>
                      <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                        {abstract.score && abstract.score.length > 0 ? (
                          <span style={{
                            display: 'inline-block', padding: '2px 10px', borderRadius: '12px',
                            fontSize: '12px', fontWeight: 600,
                            backgroundColor: '#dcfce7', color: '#166534',
                          }}>
                            Yes ({abstract.score.length})
                          </span>
                        ) : (
                          <span style={{
                            display: 'inline-block', padding: '2px 10px', borderRadius: '12px',
                            fontSize: '12px', fontWeight: 600,
                            backgroundColor: '#fef2f2', color: '#991b1b', border: '1px dashed #fca5a5',
                          }}>
                            No
                          </span>
                        )}
                      </td>
                      <td style={{ padding: '8px 12px' }}>
                        <Link
                          to={`/revisor/abstracts/${abstract.id}`}
                          style={{
                            padding: '4px 12px', fontSize: '12px', backgroundColor: '#0b6ef6',
                            color: '#fff', borderRadius: '4px', textDecoration: 'none',
                            fontWeight: 600, whiteSpace: 'nowrap',
                          }}
                        >
                          Review
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Cards view */}
          {viewMode === 'cards' && (
          <div className="snn-expand-grid-4">
            {(sortedAbstracts || []).map((abstract) => (
              <Link key={abstract.title} to={`/revisor/abstracts/${abstract.id}`}>
                <div
                  className={
                    'snn-abstract-registered-card' +
                    {
                      'Advanced materials and physics of nanostructures':
                        ' snn-user-home-abstract-advanced',
                      Bionanotechnology: ' snn-user-home-abstract-bio',
                      Nanophotonics: ' snn-user-home-nanophotonic',
                      'Physical-chemistry of nanomaterials and nanocatalysis':
                        ' snn-user-home-catalysis',
                      'Tech innovation in nanoscience': ' snn-user-home-innovation',
                    }[abstract.category] +
                    (abstract.status === 'Submitted'
                      ? ' snn-abstract-registered-card-submitted'
                      : ' snn-abstract-registered-card-draft')
                  }
                >
                  <p className="snn-user-home-main-content-small-text">{abstract.status}</p>
                  <div className="snn-abstract-registered-card-text">
                    <div className="snn-revisor-card-wrapper-content">
                      <p className="snn-user-home-main-content-large-semi">{abstract.title}</p>
                      <div>
                        <p className="snn-user-home-main-content-small-text snn-user-revisor-authors">
                          {abstract.authors.map((a, index) => {
                            if (a.correspondingAuthor) {
                              if (index > 0) {
                                return (
                                  <>
                                    <span key={index}>, </span>
                                    <strong key={a.lastName}>
                                      {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                    </strong>
                                    <sup>, *</sup>
                                  </>
                                );
                              } else {
                                return (
                                  <>
                                    <strong key={a.lastName}>
                                      {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                    </strong>
                                    <sup>*</sup>
                                  </>
                                );
                              }
                            } else {
                              if (index > 0) {
                                return (
                                  <>
                                    <span key={index}>, </span>
                                    <span key={a.lastName}>
                                      {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                    </span>
                                  </>
                                );
                              } else {
                                return (
                                  <span key={a.lastName}>
                                    {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                  </span>
                                );
                              }
                            }
                          })}
                        </p>
                        <p>
                          {abstract.authors
                            .filter((a) => a.correspondingAuthor)
                            .map((a) => a.email)
                            .join(', ')}
                        </p>
                        {abstract.score ? (
                          <p>
                            <strong>Number of revisions: </strong> {abstract.score.length}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <img src={TopicsList.filter((t) => t.name === abstract.category)[0].src_bg} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
          )}
          </div>
        </div>
      </div>
    </div>
  );
};
